import script from "./SpiritualHome.vue?vue&type=script&setup=true&lang=js"
export * from "./SpiritualHome.vue?vue&type=script&setup=true&lang=js"

import "./SpiritualHome.vue?vue&type=style&index=0&id=7c044e09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c044e09"]])

export default __exports__